










































import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import {
  compose, join, over, lensIndex, toUpper, clone,
} from 'ramda'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import { db } from '../firebase/init'
import MainMixin from '../mixins/MainMixin'
import ServerReport from '../components/forms/ServerReport.vue'
import IncidentReport from '../components/forms/IncidentReport.vue'
import ManagerReport from '../components/forms/ManagerReport.vue'
import WrittenCheck from '../components/forms/WrittenCheck.vue'
import NewMessage from '../components/forms/NewMessage.vue'
// import JokerDraw from '../components/forms/JokerDraw.vue'
import CommentCard from '../components/forms/CommentCard.vue'
import ContactCard from '../components/forms/ContactCard.vue'
import {
  IncidentReportType, ManagerReportType, ServerReportType, NewMessageType,
} from '../types'

const uppercase = (x:string) => {
  const words = x.split('-')
  return words[0] + words[1].charAt(0).toUpperCase() + words[1].slice(1)
}

@Component({
  components: {
    ServerReport,
    IncidentReport,
    ManagerReport,
    WrittenCheck,
    NewMessage,
    // JokerDraw,
    CommentCard,
    ContactCard,
  },
})
export default class Forms extends Mixins(MainMixin) {
  @Prop({ default: '' }) id!:string

  activeForm:any = {}

  $refs:any

  reports = {
    'server-report': ServerReport,
    'incident-report': IncidentReport,
    'manager-report': ManagerReport,
    'written-check': WrittenCheck,
    'new-message': NewMessage,
    'comment-card': CommentCard,
    // 'joker-draw': JokerDraw,
    'contact-card': ContactCard,
  }

  loading = false

  // get canClick() {
  //   return this.activeForm === 'all' ? 'click' : ''
  // }

  // showAll() {
  //   this.activeForm = 'all'
  // }

  // get activeFormData() {
  //   return this.formLinks.find(f => f.link === this.activeForm)
  // }

  // get allShifts() {
  //   return this.$store.getters.allShifts
  // }

  formLinks = [
    {
      title: 'Incident Report', type: 'IncidentReportType', link: 'incident-report', description: 'All Types of Incidents', submitReturn: true,
    },
    {
      title: 'Manager Report', type: 'IncidentReportType', link: 'manager-report', description: 'Daily Report for Managers', manager: true,
    },
    {
      title: 'New Message', type: 'NewMessageType', link: 'new-message', description: 'Messages - Email, In-Person, or Misc.',
    },
    {
      title: 'Server Report', type: 'IncidentReportType', link: 'server-report', description: 'Daily Server Report',
    },
    {
      title: 'Written Check', type: 'WrittenCheckType', link: 'written-check', description: 'Fill Out For Every Written Check',
    },
    {
      title: 'Comment Card', type: 'IncidentReportType', link: 'comment-card', description: 'Input any Written Comment Cards', submitReturn: true,
    },
    // {
    //   title: 'Joker Draw', type: 'IncidentReportType', link: 'joker-draw', description: 'Input Joker Draw Cards', submitReturn: true,
    // },
    {
      title: 'Contact Card', type: 'IncidentReportType', link: 'contact-card', description: 'Input Any New Contact Cards', submitReturn: true,
    },
  ]

  // get formType() {
  //   return this.activeForm.type
  // }
  async submitForm(d:any) {
    if (!(this.$refs.formComponent)) return false
    const form:any = (this.$refs.formComponent as ServerReport[])
    const isValid = await form.$refs.obs.validate()
    console.log('isValid: ', isValid)
    if (!isValid) {
      return this.$toast.error('Form Incomplete - Please Check Your Entries')
    }
    this.loading = true
    const data = clone(d)
    await this.preSubmitHook()
    // eslint-disable-next-line prefer-destructuring
    data.created = new Date()
    data.createdBy = this.uid
    const formId:string = uppercase(this.activeForm.link)
    const formCollection = db.collection(`locations/${this.$store.getters.location}/forms/${formId}/submissions`)
    await formCollection.add(data)
    this.loading = false
    this.$toast.success('Success - Your Form Has Been Submitted!')
    this.clearForm()
    if (this.activeForm.submitReturn !== true) {
      return this.$router.push('/forms')
    }
    return true
  }

  get showForm() {
    return (this.activeForm && this.activeForm.link)
  }

  clearForm() {
    console.log('asdf', this.$refs.formComponent)
    window.localStorage.removeItem(`${this.$store.getters.location}-mreportdata`)
    if (!this.$refs.formComponent) {
      return false
    }
    (this.$refs.formComponent as ServerReport & { clearForm: () => void }
    ).clearForm()
    return true
  }


  async preSubmitHook() {
    if (!this.$refs.formComponent) {
      return false
    }
    if (!this.$refs.formComponent.presubmit) return true
    await (this.$refs.formComponent as ServerReport[] & { presubmit: () => void }
    ).presubmit()
    return true
  }

  created() {
    if (this.$route.query && this.$route.query.form) {
      this.activeForm = this.$route.query.form as string
    }
  }

  @Watch('$route.params.id', { immediate: true, deep: true })
  newForm(form:string) {
    console.log('going to ', form)
    if (form) {
      this.activeForm = this.formLinks.find(f => f.link === form)
    } // testr
  }
}

